import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useAuthStore } from '@creditify/shared-fe/stores/auth'
// Flexoki design tokens MUST load before Tailwind so the semantic CSS vars
// (--bg, --fg, ...) that Tailwind's colours reference are defined first.
import '@creditify/shared-fe/styles/flexoki.css'
import './styles/tailwind.css'
import App from './App.vue'
import { router } from './router'

const app = createApp(App)
app.use(createPinia())
app.use(router)

// Initialize auth from refresh token before mounting so route guards can
// redirect synchronously based on isAuthenticated.
const auth = useAuthStore()
auth.initialize().finally(() => {
  app.mount('#app')
})
